import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _CLINIC_SETTINGS, _GENDER_TYPE, _PERSONALIZED_SUPPLEM;

import Cookies from 'js-cookie';
import { Gender, OrgID, PersonalizedSupplementStatus } from 'src/types';
import { AuFaitEnvVariables, CofitEnvVariables, CymbalEnvVariables, CymbalxinlinEnvVariables, FCLabEnvVariables, GenesisEnvVariables, GenesisHCEnvVariables, GenesisKHEnvVariables, LumezEnvVariables, LumezGenesisEnvVariables, TestingEnvVariables, TianyiEnvVariables, YouCofitHQEnvVariables } from './branches';
import { commonSettings } from './commonSettings';
import { BRANCH_LOCAL_STORAGE_KEY } from './localStorageKey';
export var CLINIC_SETTINGS = (_CLINIC_SETTINGS = {}, _defineProperty(_CLINIC_SETTINGS, OrgID.Genesis, GenesisEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.Lumez, LumezEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.Testing, TestingEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.Cymbal, CymbalEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.Cymbalxinlin, CymbalxinlinEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.GenesisKH, GenesisKHEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.GenesisHC, GenesisHCEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.LumezGenesis, LumezGenesisEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.Tianyi, TianyiEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.Cofit, CofitEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.FCLab, FCLabEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.YouCofitHQ, YouCofitHQEnvVariables), _defineProperty(_CLINIC_SETTINGS, OrgID.AuFait, AuFaitEnvVariables), _CLINIC_SETTINGS);
export var getBranchInfoFromBranchID = function getBranchInfoFromBranchID(branchID) {
  return Object.values(CLINIC_SETTINGS).find(function (branchConstant) {
    return branchConstant.BRANCH_ID === branchID;
  });
};
export var getClinicInfoFromBranchID = function getClinicInfoFromBranchID(branchID) {
  var _getBranchInfoFromBra;

  return (_getBranchInfoFromBra = getBranchInfoFromBranchID(branchID)) === null || _getBranchInfoFromBra === void 0 ? void 0 : _getBranchInfoFromBra.CLINIC_INFO;
};
export var WEEKS_IN_ONE_PERIOD = 8; // 8 weeks

export var DAYS_IN_ONE_PERIOD = WEEKS_IN_ONE_PERIOD * 7; // 8 weeks

export var HASURA_COOKIE_NAME = 'hasura_token';
export var GRAPHQL_ENDPOINT = process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT;
export var GTM_PREVIEW = process.env.NEXT_PUBLIC_GTM_PREVIEW;
export var GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || 'GTM-MXJBB8FM';
export var GTM_AUTH = process.env.NEXT_PUBLIC_GTM_AUTH; // The Domain attribute restricts the hosts that the cookie will be sent to.
// The SameSite attribute restricts the origins from which the cookie may be sent.

var COOKIE_DOMAIN; // production
//  => the cookie will only apply to the request domain, and will only be sent for requests to the exact same domain, not any other subdomains.

if (commonSettings.isTestingEnv) {
  COOKIE_DOMAIN = '.vercel.cofit.me'; // can be sent to xxx.vercel.cofit.me
} else if (commonSettings.isDevelopmentEnv) {
  COOKIE_DOMAIN = 'localhost';
}

export var cookiesOptions = {
  path: '/',
  sameSite: 'Lax',
  expires: new Date(Date.now() + 86400 * 1000 * 7) // 7 days

};

if (COOKIE_DOMAIN && !process.env.NEXT_PUBLIC_CI_TEST) {
  cookiesOptions.domain = COOKIE_DOMAIN;
}

if (!commonSettings.isDevelopmentEnv && !process.env.NEXT_PUBLIC_CI_TEST) {
  cookiesOptions.secure = true;
}

var protocol = commonSettings.isDevelopmentEnv ? 'http' : 'https';
export var CHAT_SOCKET_IO_DOMAIN = process.env.NEXT_PUBLIC_WEB_SOCKET_ORIGIN;
export var CHAT_SOCKET_IO_URL = "".concat(protocol, "://").concat(CHAT_SOCKET_IO_DOMAIN);
export var CHAT_TAG_EXTRACT_PATTERN = /@\[id=(.*?)&type=(.*?)]\(([^)]*)\)/;
export var EMPTY_HTML = '<p></p>';
export var get_NO_RECORD_HTML_STRING = function get_NO_RECORD_HTML_STRING(t) {
  return "<span style=\"color:#A2A2A2;font-size:16px\">".concat(t ? t('common:normal.noRecord', '無紀錄') : '無紀錄', "</span>");
};
export var CURRENT_ORG_ID = OrgID.Testing;
export var BranchConstants = CLINIC_SETTINGS[CURRENT_ORG_ID];
export function isCofit() {
  return CURRENT_ORG_ID === OrgID.Cofit;
}
export function updateOrgInfoOnServer(host) {
  var settings = Object.values(CLINIC_SETTINGS).find(function (clinicSettings) {
    var _host$split;

    var subDomain = (_host$split = host.split('.')) === null || _host$split === void 0 ? void 0 : _host$split[0];
    var domain = clinicSettings.SUB_DOMAINS.find(function (item) {
      return host === item || subDomain === item;
    });
    return !!domain;
  });
  CURRENT_ORG_ID = (settings === null || settings === void 0 ? void 0 : settings.ORG_ID) || OrgID.Testing;
  BranchConstants = CLINIC_SETTINGS[CURRENT_ORG_ID];
  return BranchConstants.BRANCH_CODE;
}
export function updateOrgInfoOnClient() {
  var _settings;

  var settings; // For development and testing environment only, get orgCode from storage

  if (commonSettings.FEATURES.branchSelector) {
    var code = localStorage.getItem(BRANCH_LOCAL_STORAGE_KEY);
    settings = Object.values(CLINIC_SETTINGS).find(function (clinicSettings) {
      return clinicSettings.BRANCH_CODE === code;
    });
  } // Default behavior: get orgCode from cookie set by next.js request middleware (domain-dependent)


  if (!settings) {
    var _Cookies$get;

    var orgCODE = Cookies === null || Cookies === void 0 ? void 0 : (_Cookies$get = Cookies.get) === null || _Cookies$get === void 0 ? void 0 : _Cookies$get.call(Cookies, 'orgCODE');
    settings = Object.values(CLINIC_SETTINGS).find(function (clinicSettings) {
      return clinicSettings.BRANCH_CODE === orgCODE;
    });
  }

  CURRENT_ORG_ID = ((_settings = settings) === null || _settings === void 0 ? void 0 : _settings.ORG_ID) || OrgID.Testing;
  BranchConstants = CLINIC_SETTINGS[CURRENT_ORG_ID];
  return CURRENT_ORG_ID;
}
export var GENDER_TYPE = (_GENDER_TYPE = {}, _defineProperty(_GENDER_TYPE, Gender.female, {
  text: '女性',
  shortText: '女',
  key: Gender.female,
  i18n: 'common:normal.female',
  shortI18n: 'common:normal.femaleShort'
}), _defineProperty(_GENDER_TYPE, Gender.male, {
  text: '男性',
  shortText: '男',
  key: Gender.male,
  i18n: 'common:normal.male',
  shortI18n: 'common:normal.maleShort'
}), _GENDER_TYPE);
export var PERSONALIZED_SUPPLEMENT_STATUS_TYPE = (_PERSONALIZED_SUPPLEM = {}, _defineProperty(_PERSONALIZED_SUPPLEM, PersonalizedSupplementStatus.safe, {
  text: '正常',
  key: PersonalizedSupplementStatus.safe,
  i18n: 'common:normal.safe',
  color: '#5CAD69'
}), _defineProperty(_PERSONALIZED_SUPPLEM, PersonalizedSupplementStatus.risky, {
  text: '注意',
  key: PersonalizedSupplementStatus.risky,
  i18n: 'common:normal.risky',
  color: '#ECC94B'
}), _defineProperty(_PERSONALIZED_SUPPLEM, PersonalizedSupplementStatus.dangerous, {
  text: '危險',
  key: PersonalizedSupplementStatus.dangerous,
  i18n: 'common:normal.dangerous',
  color: '#F45B5B'
}), _PERSONALIZED_SUPPLEM);
export * from './commonSettings';
export * from './consulting';
export * from './doctors';
export * from './escapePatterns';
export * from './localStorageKey';
export * from './measurement';
export * from './memo';
export * from './menu';
export * from './password';
export * from './soap';
export * from './survey';
export * from './url';
export * from './version';